import { Button, Typography, useUiLabel } from '@canvas-logic/clp-shared-ui';


import styles from './ViewportErrorBoundary.module.css';

interface Props {
  onRetry: () => void;
}

export const ViewportErrorFallback = ({ onRetry }: Props) => {
  const unavailableLabel = useUiLabel('ui.viewer3d.unavailable');
  const reloadLabel = useUiLabel('ui.viewer3d.reloadButton');

  return (
    <div className={styles.fallback}>
      <Typography variant="heading3">{unavailableLabel}</Typography>
      <Button variant="ternary" onClick={onRetry}>
        {reloadLabel}
      </Button>
    </div>
  );
};
